import { render, staticRenderFns } from "./ComposeMailDialog.vue?vue&type=template&id=fe87d106&scoped=true"
import script from "./ComposeMailDialog.vue?vue&type=script&lang=js"
export * from "./ComposeMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe87d106",
  null
  
)

export default component.exports